module.exports = __webpack_public_path__ + "img/mainpage_img.0de3f447.jpg";